import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../../Zemplin/General/Title';
import { TextP } from '../../Defaults/Text';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { Tag, TagType } from '../Product/Tag';
import InfoRow from './InfoRow';

interface Props {
  title: string;
  image: string;
  desc: string;
  userPlu: string;
  onChange: () => void;
  theme: any;
  shareButton: React.Component;
}

function LeftUpper({
  image,
  desc,
  userPlu,
  onChange,
  theme,
  shareButton,
}: Props) {
  return (
    <Wrapper>
      <ImgDescWrapper>
        <ImageWrapper imgSrc={image}>
          <TagWrapper>
            <TagRelativeWrapper>
              <Tag type={TagType.NEW} text={'NOVÉ'} />
            </TagRelativeWrapper>
          </TagWrapper>
        </ImageWrapper>
      </ImgDescWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  color: #aaaaaa;
  position: relative;

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-bottom: ${rem(32)};
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const ImageWrapper = styled.div<{ imgSrc: string }>`
  max-width: ${rem(328)};
  min-width: ${rem(288)};
  height: ${rem(328)};
  width: 100%;
  background-image: url('${({ imgSrc }) => imgSrc}');
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  margin-right: ${rem(32)};
  border: ${({ theme }) => theme.borders.primary};
  border-radius: ${rem(4)};
`;

const ImgDescWrapper = styled(FlexRow)`
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    flex-flow: column;
  `}
`;

const DescPluWrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(448)};
`;

const TagRelativeWrapper = styled.div`
  margin-right: ${rem(8)};
`;

const TagWrapper = styled(FlexRow)`
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 300;
  line-height: ${rem(22)};
`;

const UserPluWrapper = styled(FlexRowCenterVertical)`
  margin-top: ${rem(16)};
`;

const Description = styled(Text)`
  margin-bottom: ${rem(24)};
`;

const WithThemeLeftUpper: any = withTheme(LeftUpper);

export { WithThemeLeftUpper as DsiLeftUpper };
